/* eslint-disable import/prefer-default-export */

export const CLASSIFICATION_BROWSE_COLUMNS = {
  ID: 'id',
  NAME: 'name',
  TYPE_IDS: 'typeIds',
  SHELVING_ALGORITHM: 'shelvingAlgorithm',
};
